<script lang="ts">
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";

  const reactivationBannerType = "reactivation_banner";

</script>

<div class="fizz-flex-item fizz-inset-square-16" data-testid={reactivationBannerType}>
  <div class="fizz-alert-info">
    <p><strong>ProviPay account reactivated</strong></p>
    <p class="fizz-text-medium fizz-stack-4">
      Your account has been successfully reactivated. Please update your payment method, reschedule
      any missed payments, and enable autopay.
    </p>
    <UIRouterLink stateName={`layout.invoice_settings`} classes={"fizz-text-medium"}>
      <button class="fizz-button fizz-button-small">Update payment settings</button>
    </UIRouterLink>
  </div>
</div>
